<div class="transaction-tab-content">
  <div class="transaction-table-wrapper" *ngIf="transactions.length > 0">
    <div class="history-table-wrapper">
      <p-table
        [value]="flattenedTransactions"
        [loading]="refreshing"
        styleClass="transaction-history-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="col-select text-center"></th>
            <th class="col-invoiceno">Invoice No</th>
            <th class="col-customer">Customer</th>
            <th class="col-date">Invoice Date</th>
            <th class="col-amount text-end">Subtotal</th>
            <th class="col-amount text-end">Tax</th>
            <th class="col-amount text-end">Grand Total</th>
            <th *ngIf="isLoyaltyEnabled" class="col-loyalty text-center">Loyalty</th>
            <th class="col-status text-center">Status</th>
            <th class="col-download text-center">Receipt</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-transactionItem
          let-rowIndex="rowIndex"
        >
          <tr
            [tabindex]="400 + rowIndex"
            [attr.data-transaction-index]="rowIndex"
            [attr.aria-label]="
              'Transaction item ' +
              transactionItem.psid +
              ' for ' +
              (transactionItem.price | currency: 'INR')
            "
            (click)="onTransactionSelectByIndex(rowIndex, $event)"
            [class.selected-row]="selectedTransactionIndex === rowIndex"
            class="transaction-row-clickable"
          >
            <td class="col-select text-center">
              <p-radioButton
                name="transactionSelection"
                [value]="rowIndex"
                [(ngModel)]="selectedTransactionIndex"
                [inputId]="'transaction_' + rowIndex"
                (onClick)="onTransactionSelectByIndex(rowIndex)"
              >
              </p-radioButton>
            </td>

            <td class="col-invoiceno">
              <span
                class="invoice-no-text"
                [innerHTML]="
                  highlightSearchTerm(transactionItem.invoiceno.toString())
                "
              ></span>
            </td>

            <td class="col-customer">
              <div
                class="customer-cell"
                [title]="transactionItem.name || 'Walk in Customer'"
              >
                <span
                  class="customer-name"
                  [innerHTML]="
                    highlightSearchTerm(
                      (transactionItem.name || 'Walk in Customer').toString()
                    )
                  "
                ></span>
                <span
                  class="customer-id"
                  *ngIf="transactionItem.user_id"
                  [innerHTML]="
                    highlightSearchTerm(transactionItem.user_id.toString())
                  "
                ></span>
              </div>
            </td>

            <td class="col-date">
              <div class="date-time-info">
                <div class="date">
                  {{ transactionItem.invoicedate | date: "dd-MM-yyyy" }}
                </div>
                <div class="time">
                  {{ transactionItem.createdAt | date: "h:mm a" }}
                </div>
              </div>
            </td>

            <td class="col-amount text-end">
              <span class="tabular-num"
                >₹{{ transactionItem.subtotal | number: "1.2-2" }}</span
              >
            </td>

            <td class="col-amount text-end">
              <span class="tabular-num text-muted"
                >₹{{ transactionItem.taxamount | number: "1.2-2" }}</span
              >
            </td>

            <td class="col-amount text-end">
              <span class="tabular-num grand-total-amount"
                >₹{{ transactionItem.amount | number: "1.2-2" }}</span
              >
            </td>

            <td *ngIf="isLoyaltyEnabled" class="col-loyalty text-center">
              <ng-container
                *ngIf="
                  (transactionItem.redeempoints || 0) > 0 ||
                    (transactionItem.redeempointamt || 0) > 0;
                  else noLoyaltyInvoice
                "
              >
                <span class="loyalty-badge">
                  ₹{{ transactionItem.redeempointamt || 0 | number: "1.2-2" }}
                  <span class="loyalty-pts"
                    >({{ transactionItem.redeempoints || 0 }} pts)</span
                  >
                </span>
              </ng-container>
              <ng-template #noLoyaltyInvoice
                ><span class="dash-muted">-</span></ng-template
              >
            </td>

            <td class="col-status text-center">
              <span
                class="status-pill status-{{
                  (transactionItem.status || 'completed').toLowerCase()
                }}"
              >
                <span class="status-dot"></span>
                <span>{{ transactionItem.status || "Completed" }}</span>
              </span>
            </td>

            <td class="col-download text-center">
              <button
                *ngIf="transactionItem.invoicepdf"
                type="button"
                class="download-btn-modern"
                (click)="
                  downloadInvoicePdf(
                    transactionItem.invoicepdf,
                    transactionItem.invoiceno,
                    $event
                  )
                "
                title="Download Invoice PDF"
              >
                <i class="pi pi-download"></i>
              </button>
              <button
                *ngIf="transactionItem.invoiceno && whatsappShareService.allowed"
                type="button"
                class="download-btn-modern whatsapp-btn"
                [disabled]="sharingInvoiceNo === transactionItem.invoiceno"
                (click)="shareInvoiceWhatsapp(transactionItem, $event)"
                [title]="
                  whatsappShareService.apiEnabled
                    ? 'Send Invoice on WhatsApp'
                    : 'Share Invoice on WhatsApp'
                "
              >
                <i
                  class="pi"
                  [ngClass]="
                    sharingInvoiceNo === transactionItem.invoiceno
                      ? 'pi-spin pi-spinner'
                      : 'pi-whatsapp'
                  "
                ></i>
              </button>
              <span
                *ngIf="!transactionItem.invoicepdf && !transactionItem.invoiceno"
                class="dash-muted"
                >-</span
              >
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div *ngIf="transactions.length == 0" class="history-empty">
    <ng-container *ngIf="refreshing; else noTransactions">
      <i class="pi pi-spin pi-spinner"></i>
      <p class="history-empty__title">Loading transactions…</p>
    </ng-container>
    <ng-template #noTransactions>
      <i class="pi pi-receipt"></i>
      <p class="history-empty__title">No transactions yet</p>
      <p class="history-empty__hint">Completed sales will appear here.</p>
    </ng-template>
  </div>
</div>

<div *ngIf="showFooter" class="premium-footer">
  <button
    class="premium-btn premium-btn-secondary"
    (click)="refreshHistoryData()"
    [disabled]="refreshing"
    tabindex="501"
    type="button"
    [attr.aria-label]="'Refresh transaction list'"
  >
    <i class="pi pi-refresh"></i>
    Refresh
  </button>
  <button
    class="premium-btn premium-btn-primary"
    tabindex="502"
    [disabled]="selectedTransactionIndex < 0 || !flattenedTransactions.length"
    (click)="printReceipt(flattenedTransactions[selectedTransactionIndex]?.invoicepdf)"
    type="button"
  >
    <i class="pi pi-print"></i>
    Print Receipt
  </button>
</div>
